import { useMemo } from 'react'

import {
  paramsSelector,
  useStore,
  visitorPrivateActionsSelector,
} from '@liveHelper/models/store'
import { customLiveHelperEvent } from '@liveHelper/tracking/customLiveHelperEvent'
import { EventType } from '@liveHelper/tracking/eventType'
import { useTrackClickStartCall } from '@liveHelper/tracking/useLiveHelperTracking'

interface Return {
  startCall?: () => void
  terminateCall?: () => void
}

/**
 * Hook to get appointment actions
 */
export const useAppointmentActions = (): Return => {
  const { callAgent, terminateCall } = useStore(visitorPrivateActionsSelector)
  const params = useStore(paramsSelector)
  const trackClickStartCall = useTrackClickStartCall()

  return useMemo(() => {
    return {
      startCall: () => {
        callAgent?.()
        trackClickStartCall()
        customLiveHelperEvent({
          type: EventType.FW_LIVE_HELPER_CLICK_CALL_AGENT,
          data: {
            widget_id: params?.widget_id,
          },
        })
      },
      terminateCall: () => terminateCall?.({ type: 'stopDialing' }),
    }
  }, [callAgent, params?.widget_id, trackClickStartCall, terminateCall])
}
